function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.8125 11.5165L15.7567 15.6197C16.0904 15.9668 16.0794 16.5203 15.7326 16.854C15.5694 17.0112 15.3544 17.0976 15.1278 17.0976C14.8883 17.0976 14.6649 17.0024 14.4988 16.8299L10.5246 12.6956C9.39609 13.4888 8.07619 13.9067 6.69113 13.9067C3.0017 13.9067 0 10.9043 0 7.21408C0 3.52384 3.0017 0.521484 6.69113 0.521484C10.3806 0.521484 13.3823 3.52384 13.3823 7.21408C13.3823 8.79353 12.8266 10.3107 11.8125 11.5165ZM11.6367 7.21481C11.6367 4.48714 9.41816 2.26811 6.69109 2.26811C3.96402 2.26811 1.74548 4.48714 1.74548 7.21481C1.74548 9.94248 3.96402 12.1615 6.69109 12.1615C9.41816 12.1615 11.6367 9.94248 11.6367 7.21481Z",
  fill: "#1C73FF"
});
const SvgMagnifyingGlass = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgMagnifyingGlass, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/magnifying-glass.db49eb65.svg";
export { ForwardRef as ReactComponent };